import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { Popover } from '@headlessui/react';
import { AuthContext } from '../contexts/auth';
import EmployeeAttendanceTable from '../components/employee_attendance_table';
import { Link } from "wouter";
import PreviewGiustificativi from '../components/preview_giustificativi';
import Footer from '../components/footer';
import { listOrganizationalUnits } from '../services/api_org_unit';
import ComboboxAutocomplete from '../components/combobox_autocomplete';
import { getHolidaysCompanyList } from '../services/api_holiday';


export const Presence = () => {
    const [units, setUnits] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(false);
    const [currentDate] = useState(new Date());
    const [selectedUnit, setSelectedUnit] = useState(null);
    const backgroudColor = 'bg-blue-500'
    const resourceType = 'dipendenti'
    const { profile, token } = useContext(AuthContext)
    const [holidays, setHolidays] = useState([]);

    useEffect(() => {
        async function fetchData() {
            try {
                const unitsData = await listOrganizationalUnits(token, true);
                setUnits(unitsData.data);
                setIsLoading(false);
    
                const holidaysResponse = await getHolidaysCompanyList(token);
                const today = new Date().toISOString().split('T')[0];
                const parts = today.split('-');
                const month = parseInt(parts[1]);
                const day = parseInt(parts[2]);
                const todayHolidays = holidaysResponse.filter(holiday => {
                    return holiday.day === day && holiday.month === month;
                });
    
                setHolidays(todayHolidays);
            } catch (error) {
                console.error('Error fetching units:', error);
                setIsError(true);
                setIsLoading(false);
            }
        }
    
        fetchData();
    }, [token]);
    

    const allUnits = selectedUnit && selectedUnit.children
        ? units.concat(selectedUnit.children)
        : units;


    const handleSelectUnit = (selected) => {
        setSelectedUnit(selected);
    };

    const options = { weekday: 'long', year: 'numeric', month: '2-digit', day: '2-digit' };
    const formattedDate = new Intl.DateTimeFormat('it-IT', options).format(currentDate);
    

    if (isLoading) return <div>Loading...</div>;
    if (isError) return <div>Error loading data.</div>;

     return (
        <div className="min-h-full">
            <Popover as="header" className={`bg-indigo-200`}>
                <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:max-w-7xl lg:px-8">
                    <div className="relative flex flex-wrap items-center justify-center lg:justify-between">
                        <div className="w-full -5 lg:border-t lg:border-white lg:border-opacity-20">
                            <div className="flex justify-center my-2 py-2">
                                <h2 className="text-center text-2xl font-semibold text-indigo-800">Home Presenze</h2>
                            </div>
                        </div>
                    </div>
                </div>
            </Popover>
            <main className="mt-10 pb-8">
                <div className='grid md:grid-cols-5 grid-cols-1 md:mx-4 mx-6 pb-5 z-30'>
                    <div className='col-hidden lg:block lg:col-span-1'></div>
                    <div className='col-span-1 flex items-center justify-start lg:justify-end lg:me-5'>
                        <h1 className="block font-medium text-gray-700 mb-4 md:mb-0 uppercase text-sm">Unità Organizzativa</h1>
                    </div>
                    <div className='col-span-1 flex items-center w-64' style={{ zIndex: '25'}}>
                        <ComboboxAutocomplete
                            options={allUnits}
                            bgActiveColor="bg-gray-100"
                            textActiveColor="text-gray-900"
                            placeholder='Seleziona Unità Organizzativa...'
                            onChange={handleSelectUnit}
                            value={selectedUnit}
                            positionOptions='relative'
                        />
                    </div>
                </div>

                <div className="col-span-10">
                    <h1 className='m-4'>PRESENZE OGGI - 
                        <span className='font-bold text-indigo-800 uppercase'> {formattedDate}</span>
                        {holidays.length > 0 &&
                            <span className="uppercase">, festività oggi:
                                {holidays.map((holiday, index) => (
                                    <span key={index} className='font-bold text-indigo-800 uppercase ml-2'>{holiday.name}</span>
                                ))}
                            </span>
                        }
                    </h1>
                    <div className="flex flex-col items-center justify-center m-4 bg-gray-100 rounded-md pb-5">
                        <EmployeeAttendanceTable selectedUnit={selectedUnit} />
                        {/* <Link
                        to='/nuovo_dipendente'
                        className="bg-indigo-600 hover:bg-indigo-500 text-white font-bold py-2 px-4 rounded my-4"
                        >Aggiungi Dipendente</Link> */}
                    </div>
                </div>
                <div className="col-span-10 mt-10">
                    <h1 className='m-4'>RICHIESTE GIUSTIFICATIVI</h1> 
                    <div className="flex flex-col items-center justify-center m-4 bg-gray-100 pb-5">
                        <PreviewGiustificativi />
                    </div>
                </div>
            </main>
            <Footer />
        </div>
    );
};
